import { PDFViewer } from 'pdfjs-dist/legacy/web/pdf_viewer';
import CustomTextHighlighter from './customTextHighlighter';

/**
 * Overrides the viewer for the purpose of specifying the {@link CustomTextHighlighter}.
 */
export default class CustomPdfViewer extends PDFViewer {
  /**
   * @param {number} pageIndex
   * @param {EventBus} eventBus
   * @returns {CustomTextHighlighter}
   */
  createTextHighlighter(pageIndex, eventBus) {
    return new CustomTextHighlighter({
      eventBus,
      pageIndex,
      findController: this.findController,
    });
  }
}
